<script setup>
import {ref} from "vue";
import PickerPopover from "@/Components/CommunityChat/PickerPopover.vue";
import {loadEmojiPicker} from "@/Components/CommunityChat/loadEmojiPicker.js";

const emit = defineEmits(['pick'])

const loaded = ref(false)
const pickerEl = ref(null)

// emoji-picker-element registers a real custom element (customElements.define), which needs
// the browser's `customElements` global - loading it eagerly at module scope would run during
// the SSR build of this page (community chat is rendered on the SSR'd homepage) and crash the
// Node renderer. Loading it lazily, on first open, keeps it entirely client-side.
const onOpen = async () => {
    if (loaded.value) return
    await loadEmojiPicker()
    loaded.value = true
}

const onEmojiClick = (event) => {
    const unicode = event.detail?.unicode
    if (unicode) emit('pick', unicode)
}
</script>

<template>
    <PickerPopover @open="onOpen">
        <template #trigger>
            <img src="/assets/icons/smile.svg" alt="" class="w-6 h-6"/>
        </template>
        <template #default>
            <emoji-picker v-if="loaded" ref="pickerEl" @emoji-click="onEmojiClick" class="chat-emoji-picker"/>
            <div v-else class="w-72 h-72 flex items-center justify-center text-sm text-slate-400">
                {{ $t('Loading...') }}
            </div>
        </template>
    </PickerPopover>
</template>

<style>
.chat-emoji-picker {
    --num-columns: 7;
    width: min(320px, calc(100vw - 2rem));
    height: 360px;
}

.dark .chat-emoji-picker {
    --background: #1e2433;
    --border-color: #334155;
    --indicator-color: #67e8f9;
}
</style>
